import { CART_DEFAULT, PERSONALIZATIONS_DEFAULT } from "../App.constants";

export const createCheckout = async (
  cart = CART_DEFAULT,
  personalizations = PERSONALIZATIONS_DEFAULT,
) => {
  let success;
  const data = {
    metalCards: cart.metal,
    goldCards: cart.gold,
    woodCards: cart.wood,
    personalizations: [
      ...(personalizations.metal
        ? personalizations.metal
            .filter(Boolean)
            .map((text) => ({ type: "metal", text }))
        : []),
      ...(personalizations.wood
        ? personalizations.wood
            .filter(Boolean)
            .map((text) => ({ type: "wood", text }))
        : []),
      ...(personalizations.gold
        ? personalizations.gold
            .filter(Boolean)
            .map((text) => ({ type: "gold", text }))
        : []),
    ],
  };

  fetch("https://splitpass.satoshi-ltd.com/stripe/create-checkout-session", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      // eslint-disable-next-line
      const stripe = Stripe(
        "pk_live_51Qmtf0ECBhl5oAxrypE0qdFNz60XTbcw3uhIuRpAomtmwEqQmu0ftn7sq5jqqCf2J6M88HTCSkiOoJ8lP0LNKe8x008wGHyY5Y",
      );
      stripe.redirectToCheckout({ sessionId: data.sessionId });
      success = true;
    })
    .catch((error) => {
      success = false;
    });

  return success;
};
